export const getFutureYears = (numYears: number): number[] => {
  const currentYear: number = new Date().getFullYear();
  const futureYears: number[] = [];

  for (let i: number = 0; i < numYears; i++) {
    futureYears.push(currentYear + i);
  }

  return futureYears;
};
